// Include Plugins
window.jRespond = window.jRespond || require('jRespond');
var attachFastClick = require('fastclick');

// inlude modules
var Calendar = require('./modules/calendar.js');
var Homepage = require('./modules/homepage.js');
var Navigation = require('./modules/navigation.js');

var Global = {};

(function ($) {
    'use strict';

    Global = function () {

        var self = {}, __self = {};

        self.init = function () {

            // DOM Elements
            __self.$headerOverlay = $('.site-header .-overlay');
            __self.$anchorLinks = $('.-anchor-list .-list-item > a');
            __self.$equalHeightParent = $('.-equal-height-parent');
            __self.$selects = $('#main select');
            __self.$tables = $('.content table');
            __self.$calendarViewToggle = $('#tribe-bar-views label');

            try {
                attachFastClick(document.body);
            } catch (err) {
                console.log('attachFastClick failed');
            }

            // Initialize Modules
            self.calendar = new Calendar();
            self.homepage = new Homepage();
            self.navigation = new Navigation();

            // Initialize Global Functions
            self.equalHeight();
            self.wrapSelects();
            self.wrapTables();
            self.animateLogo();

            // Events
            __self.$anchorLinks.on('click', self.anchorScroll);
            // __self.$calendarViewToggle.on('click', self.calendarViewToggle);

            $(window).on('orientationchange', self.updateOrientation);

            $(window).on('resize', function() {
                self.calendar.resize();
                self.homepage.resize();
                self.navigation.resize();
                self.equalHeight();
            });
        };

        self.anchorScroll = function(event) {
            event.preventDefault();
            var y = parseInt($(this.hash).offset().top + $('#app').scrollTop());
            $('#app').animate({scrollTop:y - 20}, 800);
        }

        self.calendarViewToggle = function() {
            $(this).parent().find('.tribe-bar-views-list').slideToggle('fast');
        }

        self.equalHeight = function() {
            __self.$equalHeightParent.each(function() {
                var $equalParent = $(this);
                var $theseEqualBlocks = $equalParent.find('.-equal-height');
                var maxHeight = 0;
                $theseEqualBlocks.css('height', 'auto');
                $theseEqualBlocks.each(function() {
                    var thisHeight = $(this).outerHeight();
                    maxHeight = Math.max(maxHeight, thisHeight)
                });
                $theseEqualBlocks.css('height', maxHeight + 'px');
            });
        };

        self.wrapSelects = function() {
            __self.$selects.each(function() {
                $(this).wrap('<div class="select-wrapper"></div>');
            });
        };

        self.wrapTables = function() {
            __self.$tables.each(function() {
                $(this).wrap('<div class="table-wrapper"></div>');
            });
        };

        self.animateLogo = function() {
            var globalEase = Power0.easeNone;

            var waveTl = new TimelineMax({
                  repeat: -1,
              });

            waveTl.timeScale(4);

            waveTl.to('.wave--0', 1, {morphSVG:'.wave--1', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--2', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--3', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--4', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--5', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--6', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--7', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--8', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--9', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--10', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--11', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--12', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--13', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--14', ease: globalEase})
            .to('.wave--0', 1, {morphSVG:'.wave--15', ease: globalEase});

            // console.log('animating logo');
        };

        self.updateOrientation = function () {
            // fixes the iOS 7.1 grey bar caused by the minimal-ui meta tag on orientation change
            window.scrollTo(0, 0);
        };

        $(document).ready(function () {
            self.init();
        });

        return self;
    };

    window.app = new Global();

}(window.jQuery));

module.exports = Global;
